import React, { FC } from "react";

import { Button, LinearProgress, Typography } from "@mui/material";

import useQuota from "../hooks/use-quota";
import { setBannerMessage } from "../slices/pricing_info";
import { useDispatch } from "../store";
import { Quotas } from "../store/pomeriumApi";

interface Props {
  quota: keyof Quotas;
  label: string;
}

const Quota: FC<React.PropsWithChildren<Props>> = ({ quota, label }) => {
  const dispatch = useDispatch();
  const { count, limit, isLoading } = useQuota(quota);

  const handleClick = () => dispatch(setBannerMessage(""));
  let value = 0;
  if (!isLoading && limit != 0) {
    value = Math.min((100 * (count ?? 0)) / limit, 100);
  }
  return (
    <Button
      variant="outlined"
      onClick={handleClick}
      sx={{
        borderRadius: 99,
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      <Typography color="text.secondary" fontSize="small">
        {count} / {limit} {label}
      </Typography>
      {isLoading ? (
        <LinearProgress />
      ) : (
        <LinearProgress
          variant="determinate"
          value={value}
          sx={{
            "& .MuiLinearProgress-bar": {
              transition: "none",
            },
          }}
        />
      )}
    </Button>
  );
};
export default Quota;
